import { ActionTypes } from './actionsTypes';

export const getReportingList = (payload) => ({
  type: ActionTypes.GET_REPORTING_LIST,
  payload,
});
